export default function navigationInit() {
    const headerWrapper = document.querySelector("#main-index-nav .header-wrapper");
    const mainHeader = document.querySelector("#main-index-nav .cd-main-header");
    const primaryNav = document.querySelector("#main-index-nav .cd-primary-nav");

    console.log("headerWrapper: ", headerWrapper);
    console.log("mainHeader: ", mainHeader);
    console.log("primaryNav: ", primaryNav);

    const handleScroll = () => {
        const scroll = window.pageYOffset || document.documentElement.scrollTop;
        const addClasses = (element, classes) => element.classList.add(...classes.split(" "));
        const removeClasses = (element, classes) => element.classList.remove(...classes.split(" "));

        if (scroll >= 350) {
            mainHeader.classList.add("fixed-top-nav");
            addClasses(headerWrapper, "fixed-top shadow d-block");
            removeClasses(headerWrapper, "d-none");
            removeClasses(primaryNav, "d-none");
            addClasses(primaryNav, "d-inline-block");
        } else {
            mainHeader.classList.remove("fixed-top-nav");
            removeClasses(headerWrapper, "fixed-top shadow d-block");
            addClasses(headerWrapper, "fixed-top shadow d-none");
            addClasses(primaryNav, "d-none");
            removeClasses(primaryNav, "d-inline-block");
        }
    };

    window.addEventListener("scroll", handleScroll);
}
